import { createSelector } from 'reselect';
import { selectCompanyBranches } from 'modules/SalaryModule/Employees/selectors';
import { getScheduleStructure } from '../../Employees/utils';
import { getBranchesOptions, getWorkWeekDays } from '../utils';

export const selectCompanyDetailData = (state) =>
  state.companySettingsReducer?.companyDetailData;

export const selectActiveBranchData = (state) =>
  state.companySettingsReducer?.activeBranch;

export const selectScheduleDetailData = (state) =>
  state.companySettingsReducer?.activeScheduleData;

export const selectScheduleDetailMessage = (state) =>
  state.companySettingsReducer?.scheduleDetailMessage;

export const selectSchedules = (state) =>
  state.companySettingsReducer?.schedules;

export const selectBranches = (state) => selectCompanyBranches(state) || [];

export const selectDefaultSchedule = createSelector(
  [selectSchedules],
  (schedules) => {
    if (!schedules || !schedules.length) {
      return null;
    }

    return schedules.find(({ siret }) => siret === '');
  }
);

export const selectInitialPageTitle = createSelector(
  [selectScheduleDetailData],
  (scheduleData) => {
    if (!scheduleData) {
      return '';
    }

    return scheduleData?.schedule?.title || '';
  }
);

export const selectDefaultPageTitle = createSelector(
  [selectDefaultSchedule],
  (scheduleData) => {
    if (!scheduleData) {
      return '';
    }
    return scheduleData?.title || '';
  }
);

export const selectBranchesOptions = createSelector(
  [selectCompanyBranches],
  (branches) => {
    if (branches && branches.length) {
      return getBranchesOptions(branches);
    }

    return [];
  }
);

export const selectFormattedSchedules = createSelector(
  [selectSchedules],
  (schedules) => {
    if (!schedules) return [];

    return schedules.map((schedule) => {
      const scheduleFormatted = getScheduleStructure(schedule.days);
      const totalHours = scheduleFormatted.reduce(
        (result, { totalInMinutes }) => result + totalInMinutes,
        0
      );
      const weekDays = getWorkWeekDays(scheduleFormatted);

      return {
        id: schedule.id,
        title: {
          text: schedule.title,
          link: schedule.id,
        },
        siret: schedule.siret || null,
        isDefault: schedule.isDefault,
        weekDays,
        total: `${Math.ceil(totalHours / 60)} h`,
        concerned: schedule.employeesCount,
      };
    });
  }
);
